import Immutable from 'immutable';
import { STATUS_TYPES, GLOBAL_MESSAGING_ID, NO_OP_ACTION_TYPE } from 'app/constants/MessagingConstants';

const AUTH_ERROR_CLASSIFICATIONS = ['invalid_token', 'RailsSessionInvalidationException'];

const isSessionExpiredError = err => AUTH_ERROR_CLASSIFICATIONS.includes(err.response?.body?.error?.classification);

const isValidUrl = urlCandidate => {
  try {
    /* eslint-disable-next-line no-new */
    new URL(urlCandidate);
    return true;
  } catch (_) {
    return false;
  }
};

const makeSuccessMessage = defaultMessage => {
  return {
    messaging: Immutable.fromJS({
      [GLOBAL_MESSAGING_ID]: {
        message: Immutable.Map({
          defaultMessage,
          id: GLOBAL_MESSAGING_ID,
          type: STATUS_TYPES.Success
        }),
        duration: 5000
      }
    }),
    type: NO_OP_ACTION_TYPE
  };
};

export { isSessionExpiredError, isValidUrl, makeSuccessMessage };
